import MuiIconButton from "@mui/material/IconButton";

export default function IconButton(props) {
  return <MuiIconButton {...props} />;
}
